document.addEventListener("DOMContentLoaded", function () {
    const fileInputs = document.querySelectorAll(".file-input");

    fileInputs.forEach(input => {
        const fileInput = document.getElementById(input.getAttribute("for"));
        const initialText = input.textContent

        if (!fileInput) return;

        fileInput.addEventListener("change", function () {
            if (fileInput.files.length > 0) {
                input.textContent = fileInput.files[0].name;
            } else {
                input.textContent = initialText;
            }
        });
    })

});